// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"p0","cardInnerHeading":"p1","editButton":"p2","formClass":"p3","inputClass":"p4","pw":"p5","enterCurrentPw":"p6","cancelButton":"p7","submitButton":"p8"};